import { expVal } from '@confluence/feature-experiments';
import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';

const resolvedPackages = new Map<string, boolean>();

let disableRelayOverride: boolean | undefined;

function isRelayDisabledByQueryParam(): boolean {
	if (disableRelayOverride !== undefined) {
		return disableRelayOverride;
	}

	try {
		if (typeof window !== 'undefined' && window.location?.search) {
			const params = new URLSearchParams(window.location.search);
			const value = params.get('disableRelay');
			disableRelayOverride = value === '1' || value === 'true';
		} else {
			disableRelayOverride = false;
		}
	} catch {
		disableRelayOverride = false;
	}

	return disableRelayOverride;
}

export function isRelayEnabled(callerPackage?: string): boolean {
	// Query param override: ?disableRelay=1 or ?disableRelay=true forces Relay off
	if (isRelayDisabledByQueryParam()) return false;

	if (process.env.BUILD_VARIANT === 'relay') return true;

	if (!callerPackage) {
		return expVal('confluence_apollo_to_relay_migration', 'isEnabled', false);
	}

	if (!resolvedPackages.has(callerPackage)) {
		if (expVal('confluence_apollo_to_relay_migration', 'isEnabled', false)) {
			// Experiment gates the per-package allow list
			const packages = StatsigConfigurations.getStringList('confluence_relay_enabled_packages', []);
			resolvedPackages.set(callerPackage, packages.includes(callerPackage));
		} else {
			resolvedPackages.set(callerPackage, false);
		}
	}

	return resolvedPackages.get(callerPackage)!;
}
